import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireAuth({ children }) {
  const { user, tenant, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen grid place-items-center text-slate-500">Carregando…</div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // v0.99.8c · Fev/2026 — Guard de isolamento vertical.
  // Tenants GOV NUNCA podem entrar no painel privado (`/app/*`) —
  // esse painel usa templates automotivos por padrão (troca de óleo,
  // cadastro de veículo, etc.), quebrando completamente a experiência
  // de um órgão público. E vice-versa: tenants privados NUNCA devem
  // conseguir abrir `/gov/*`. Detectamos pelo `tenant.sector` (fonte
  // primária, presente no login response) e redirecionamos de forma
  // hard antes do painel montar.
  const sector = (tenant?.sector || "").toString().toLowerCase();
  const isGovTenant = sector.startsWith("gov_");
  const path = location.pathname || "";
  const isGovRoute = path.startsWith("/gov");
  const isAppRoute = path.startsWith("/app") || path.startsWith("/admin-master");
  if (isGovTenant && isAppRoute && !path.startsWith("/admin-master")) {
    return <Navigate to="/gov/painel" replace />;
  }
  if (!isGovTenant && isGovRoute && user?.role !== "super_admin") {
    return <Navigate to="/app" replace />;
  }
  return children;
}
